import { Notification } from './interface';
import PropTypes from "prop-types";
import {htmlIdGenerator,EuiToast} from '@elastic/eui';
import "./style.css";


export const NotificationPanel = (props: any) => {
 
 let {children} = props

  const Success = (props: Notification) => {
    const idToast = htmlIdGenerator()()
    return(<EuiToast id={idToast} title={props.title || ""} color="success" iconType="check" 
    className="notification success" onClose={() => {props.onClose&&props.onClose(idToast)}}>
      <p>{props.message}</p>
    </EuiToast>)
  };

  const Error = (props: Notification) => {
  const idToast = htmlIdGenerator()()
  return(
    <EuiToast id={idToast} title={props.title || ""} color="danger" iconType="cross" 
    className="notification error" onClose={() => {props.onClose&&props.onClose(idToast)}}>
      <p>{props.message}</p>
    </EuiToast>
  )};

  const Warning = (props: Notification) => {
    const idToast = htmlIdGenerator()()
    return(
      <EuiToast id={idToast} title={props.title || ""} color="warning" iconType="cross" 
      className="notification warning" onClose={() => {props.onClose&&props.onClose(idToast)}}>
        <p>{props.message}</p>
      </EuiToast>
  )};

  switch (children.type) {
    case "success":
      return Success(children)
    case "error":
        return Error(children)
    case "warning":
      return Warning(children)
    default:
      return null
  }

};
export default NotificationPanel;

NotificationPanel.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
}

NotificationPanel.defaultProps = {
  type: "",
  title: "",
  message: ""
}

